//import Cookies from 'js-cookie';
//const Cookies = require('js-cookie');
import ImportCookies from 'js-cookie';
let Cookies: any;
try {
  let req = require('js-cookie');
  Cookies = req;
} catch {
  Cookies = ImportCookies;
}

import TokenSaveType from "./tokenSaveType";

type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE';

export interface HttpRequestOptions {
  signal?: AbortSignal;
  timeoutMs?: number;
}

export class HttpRequestTimeoutError extends Error {
  constructor(public timeoutMs: number) {
    super(`Сервис озвучки не ответил за ${Math.ceil(timeoutMs / 1000)} секунд. Повторите запрос.`);
    this.name = 'TimeoutError';
    Object.setPrototypeOf(this, HttpRequestTimeoutError.prototype);
  }
}

function requestAbortError(): Error {
  const error = new Error('Ожидание запроса остановлено.');
  error.name = 'AbortError';
  return error;
}

function ensureRequestNotAborted(signal?: AbortSignal | null) {
  if (signal && signal.aborted) throw requestAbortError();
}

export class HttpRequestError extends Error {
  constructor(public status: number, public payload: any, message: string) {
    super(message);
    Object.setPrototypeOf(this, HttpRequestError.prototype);
  }
}

interface IHttpRouteConfig {
  httpMethod: HttpMethod;
  path: string;
  returnsBoolean?: boolean;
  keepNullBodyFields?: boolean;
}

interface IHttpRouteBuildResult {
  requestUrl: string;
  requestData: any;
}

interface IHttpErrorPayload {
  Class: string;
  Method: string;
  ErrorMessage: string;
  IsSuccess: boolean;
  Value: null;
  StatusCode?: number;
}

interface IHttpResponsePayload {
  response: Response;
  payload: any;
}

function shouldLogHttpError(routeKey: string, status: number): boolean {
  return !(routeKey === GET_USER_INFO_ROUTE_KEY && status === 401);
}

function formatValidationErrors(payload: any): string {
  if (!payload || !payload.errors || typeof payload.errors !== 'object') {
    return '';
  }

  const parts: string[] = [];
  Object.keys(payload.errors).forEach((field) => {
    const messages = payload.errors[field];
    if (!Array.isArray(messages) || !messages.length) {
      return;
    }
    parts.push(`${field}: ${messages.join(', ')}`);
  });

  return parts.join('\n');
}

const AUTH_REFRESH_PATH = '/api/auth/refresh';
const LOGIN_ROUTE_KEY = 'AccountService.Login';
const LOGOUT_ROUTE_KEY = 'AccountService.Logout';
const GET_USER_INFO_ROUTE_KEY = 'AccountService.GetUserInfo';

const HTTP_ROUTE_MAP: { [key: string]: IHttpRouteConfig } = {
  'AccountService.GetUserInfo': { httpMethod: 'GET', path: '/api/auth/me' },
  'AccountService.Login': { httpMethod: 'POST', path: '/api/auth/login', returnsBoolean: true },
  'AccountService.Logout': { httpMethod: 'POST', path: '/api/auth/logout', returnsBoolean: true },
  'AffirmationService.Delete': { httpMethod: 'DELETE', path: '/api/affirmation/{id}', returnsBoolean: true },
  'AffirmationService.GetDetail': { httpMethod: 'GET', path: '/api/affirmation/{id}' },
  'AffirmationService.GetList': { httpMethod: 'POST', path: '/api/affirmation/list' },
  'AffirmationService.Update': { httpMethod: 'POST', path: '/api/affirmation/update', returnsBoolean: true },
  'AffirmationService.UpdateItem': { httpMethod: 'POST', path: '/api/affirmation/item' },
  'AffirmationService.DeleteItem': { httpMethod: 'DELETE', path: '/api/affirmation/item' },
  'AffirmationService.ChangeSortIndex': { httpMethod: 'POST', path: '/api/affirmation/sort', returnsBoolean: true },
  'AnimationService.DeleteAnimation': { httpMethod: 'DELETE', path: '/api/animation/{id}', returnsBoolean: true },
  'AnimationService.GetAnimations': { httpMethod: 'GET', path: '/api/animation/list' },
  'AnimationService.UpdateAnimation': { httpMethod: 'POST', path: '/api/animation/update', returnsBoolean: true },
  'BackgroundFileService.Add': { httpMethod: 'POST', path: '/api/background', returnsBoolean: true },
  'BackgroundFileService.Delete': { httpMethod: 'DELETE', path: '/api/background/{id}', returnsBoolean: true },
  'BackgroundFileService.GetDetail': { httpMethod: 'GET', path: '/api/background/{id}' },
  'BackgroundFileService.GetList': { httpMethod: 'GET', path: '/api/background/list' },
  'BackgroundFileService.ChangeSortIndex': { httpMethod: 'POST', path: '/api/background/sort', returnsBoolean: true },
  'BackgroundFileService.MoveToCategory': { httpMethod: 'POST', path: '/api/background/move', returnsBoolean: true, keepNullBodyFields: true },
  'BackgroundCategoryService.Add': { httpMethod: 'POST', path: '/api/background-category', returnsBoolean: true },
  'BackgroundCategoryService.Delete': { httpMethod: 'DELETE', path: '/api/background-category/{id}', returnsBoolean: true },
  'BackgroundCategoryService.GetDetail': { httpMethod: 'GET', path: '/api/background-category/{id}' },
  'BackgroundCategoryService.GetList': { httpMethod: 'GET', path: '/api/background-category/list' },
  'LevelService.UpdateLevel': { httpMethod: 'POST', path: '/api/level/update', returnsBoolean: true },
  'LevelService.GetLevel': { httpMethod: 'GET', path: '/api/level/{id}' },
  'LevelService.GetList': { httpMethod: 'POST', path: '/api/level/list' },
  'LevelService.DeleteLevel': { httpMethod: 'DELETE', path: '/api/level/{id}', returnsBoolean: true },
  'LanguageService.GetLanguages': { httpMethod: 'GET', path: '/api/Language' },
  'LanguageService.UpdateLanguage': { httpMethod: 'POST', path: '/api/Language', returnsBoolean: true },
  'LanguageService.DeleteLanguage': { httpMethod: 'DELETE', path: '/api/Language/{id}', returnsBoolean: true },
  'NotificationService.GetList': { httpMethod: 'POST', path: '/api/notification/list' },
  'NotificationService.Update': { httpMethod: 'PUT', path: '/api/notification/update', returnsBoolean: true },
  'NotificationService.SendCustomMessage': { httpMethod: 'POST', path: '/api/notification/send-custom', returnsBoolean: true },
  'NotificationService.GetDetail': { httpMethod: 'GET', path: '/api/notification/{id}' },
  'PromoCodeService.Delete': { httpMethod: 'DELETE', path: '/api/promo/{id}', returnsBoolean: true },
  'PromoCodeService.GetDetail': { httpMethod: 'GET', path: '/api/promo/{id}' },
  'PromoCodeService.GetList': { httpMethod: 'POST', path: '/api/promo/list' },
  'PromoCodeService.Update': { httpMethod: 'POST', path: '/api/promo/update', returnsBoolean: true },
  'ReminderService.Create': { httpMethod: 'POST', path: '/api/reminder/create', returnsBoolean: true },
  'ReminderService.Delete': { httpMethod: 'DELETE', path: '/api/reminder/{id}', returnsBoolean: true },
  'ReminderService.GetList': { httpMethod: 'POST', path: '/api/reminder/list' },
  'ReminderService.GetReminder': { httpMethod: 'GET', path: '/api/reminder/{id}' },
  'ReminderService.Update': { httpMethod: 'PUT', path: '/api/reminder/update', returnsBoolean: true },
  'ReferralService.UpsertRule': { httpMethod: 'POST', path: '/api/admin/referrals/rule/upsert', returnsBoolean: true },
  'ReferralService.GetRule': { httpMethod: 'GET', path: '/api/admin/referrals/rule/{ruleId}' },
  'ReferralService.GetRuleList': { httpMethod: 'POST', path: '/api/admin/referrals/rule/list' },
  'ReferralService.DeleteRule': { httpMethod: 'DELETE', path: '/api/admin/referrals/rule/{ruleId}', returnsBoolean: true },
  'ReferralService.ToggleRule': { httpMethod: 'PUT', path: '/api/admin/referrals/rule/{ruleId}/toggle?isActive={isActive}', returnsBoolean: true },
  'ReferralService.GetTrackingList': { httpMethod: 'POST', path: '/api/admin/referrals/tracking/list' },
  'MusicService.DeleteAlbum': { httpMethod: 'DELETE', path: '/api/music/albums/{id}', returnsBoolean: true },
  'MusicService.GetDetailAlbum': { httpMethod: 'GET', path: '/api/music/albums/{id}' },
  'MusicService.GetList': { httpMethod: 'GET', path: '/api/music/albums' },
  'MusicService.UpdateAlbum': { httpMethod: 'POST', path: '/api/music/albums/update', returnsBoolean: true },
  'MusicService.GetCategories': { httpMethod: 'GET', path: '/api/music/categories' },
  'MusicService.GetCategory': { httpMethod: 'GET', path: '/api/music/categories/{id}' },
  'MusicService.UpdateCategory': { httpMethod: 'POST', path: '/api/music/categories/update', returnsBoolean: true },
  'MusicService.ChangeSortIndex': { httpMethod: 'POST', path: '/api/music/categories/sort', returnsBoolean: true },
  'MusicService.DeleteCategory': { httpMethod: 'DELETE', path: '/api/music/categories/{id}', returnsBoolean: true },
  'RewardService.UpdateReward': { httpMethod: 'POST', path: '/api/reward/update', returnsBoolean: true },
  'RewardService.GetReward': { httpMethod: 'GET', path: '/api/reward/{id}' },
  'RewardService.GetList': { httpMethod: 'POST', path: '/api/reward/list' },
  'RewardService.DeleteReward': { httpMethod: 'DELETE', path: '/api/reward/{id}', returnsBoolean: true },
  'RewardService.GetRewardTriggers': { httpMethod: 'GET', path: '/api/reward/triggers' },
  'RewardService.ChangeSortIndex': { httpMethod: 'POST', path: '/api/reward/change-sort', returnsBoolean: true },
  'StatisticsService.GetGoalSurveyStatistics': { httpMethod: 'GET', path: '/api/statistic/survey' },
  'StatisticsService.GetMau': { httpMethod: 'GET', path: '/api/statistic/mau' },
  'StatisticsService.GetDau': { httpMethod: 'GET', path: '/api/statistic/dau' },
  'StatisticsService.GetRegistrations': { httpMethod: 'GET', path: '/api/statistic/registrations' },
  'StatisticsService.GetTopTracks': { httpMethod: 'GET', path: '/api/statistic/top-tracks' },
  'StatisticsService.GetTopAffirmations': { httpMethod: 'GET', path: '/api/statistic/top-affirmations' },
  'StatisticsService.GetPaidUsers': { httpMethod: 'GET', path: '/api/statistic/paid-users' },
  'StatisticsService.GetPromoRedemptions': { httpMethod: 'GET', path: '/api/statistic/promo-redemptions' },
  'UserService.GetList': { httpMethod: 'GET', path: '/api/statistic/paid-users' },
  'UserService.GetActiveStatistics': { httpMethod: 'GET', path: '/api/user/statistics/active' },
  'UserService.UpdateSubscription': { httpMethod: 'PUT', path: '/api/users/subscription/{userId}', returnsBoolean: true },
  'UserService.Delete': { httpMethod: 'DELETE', path: '/api/users/{userId}', returnsBoolean: true },
  'UserService.GetSurvey': { httpMethod: 'GET', path: '/api/users/survey/{userId}' },
};

function isPlainObject(value: any): boolean {
  return Object.prototype.toString.call(value) === '[object Object]';
}

function toCamelCase(value: string): string {
  if (!value) {
    return value;
  }
  return value.charAt(0).toLowerCase() + value.slice(1);
}

function toPascalCase(value: string): string {
  if (!value) {
    return value;
  }
  return value.charAt(0).toUpperCase() + value.slice(1);
}

function mapKeysDeep(value: any, keyMapper: (key: string) => string): any {
  if (Array.isArray(value)) {
    return value.map((item) => mapKeysDeep(item, keyMapper));
  }
  if (!isPlainObject(value)) {
    return value;
  }

  const mapped: any = {};
  for (const key in value) {
    if (!Object.prototype.hasOwnProperty.call(value, key)) {
      continue;
    }
    mapped[keyMapper(key)] = mapKeysDeep(value[key], keyMapper);
  }
  return mapped;
}

function pruneNilDeep(value: any): any {
  if (Array.isArray(value)) {
    return value
      .map((item) => pruneNilDeep(item))
      .filter((item) => item !== undefined);
  }
  if (!isPlainObject(value)) {
    return value === undefined || value === null ? undefined : value;
  }

  const pruned: any = {};
  for (const key in value) {
    if (!Object.prototype.hasOwnProperty.call(value, key)) {
      continue;
    }
    const nextValue = pruneNilDeep(value[key]);
    if (nextValue === undefined) {
      continue;
    }
    if (isPlainObject(nextValue) && Object.keys(nextValue).length === 0) {
      continue;
    }
    pruned[key] = nextValue;
  }

  return pruned;
}

function normalizeListRequestPayload(value: any): any {
  if (!isPlainObject(value)) {
    return value;
  }

  if (isPlainObject(value.sort)) {
    const sortFieldName = typeof value.sort.fieldName === 'string' ? value.sort.fieldName.trim() : '';
    if (!sortFieldName) {
      value.sort.fieldName = 'id';
    }
  }

  return value;
}

function mapHttpResponsePayload(payload: any, route: IHttpRouteConfig): any {
  if (!route.returnsBoolean) {
    return mapKeysDeep(payload, toPascalCase);
  }

  if (typeof payload === 'boolean') {
    return payload;
  }

  if (typeof payload === 'string') {
    const normalizedPayload = payload.trim().toLowerCase();
    if (normalizedPayload === 'true') {
      return true;
    }
    if (normalizedPayload === 'false') {
      return false;
    }
  }

  return true;
}

function appendQueryValue(params: URLSearchParams, key: string, value: any) {
  if (value === undefined || value === null || value === '') {
    return;
  }

  if (value instanceof Date) {
    params.append(key, value.toISOString());
    return;
  }

  params.append(key, String(value));
}

function buildQueryParams(params: URLSearchParams, value: any, prefix: string = '') {
  if (value === undefined || value === null) {
    return;
  }

  if (Array.isArray(value)) {
    value.forEach((item, index) => {
      const nextPrefix = prefix ? `${prefix}[${index}]` : String(index);
      buildQueryParams(params, item, nextPrefix);
    });
    return;
  }

  if (isPlainObject(value)) {
    Object.keys(value).forEach((key) => {
      const nextPrefix = prefix ? `${prefix}.${key}` : key;
      buildQueryParams(params, value[key], nextPrefix);
    });
    return;
  }

  appendQueryValue(params, prefix, value);
}

function buildRequiredListQueryParams(
  params: URLSearchParams,
  value: any,
  requiredEmptyFields: string[]
) {
  const request = isPlainObject(value) ? value : {};
  const requestWithoutRequiredFields = { ...request };

  requiredEmptyFields.forEach((field) => {
    delete requestWithoutRequiredFields[field];
  });

  buildQueryParams(params, requestWithoutRequiredFields);

  requiredEmptyFields.forEach((field) => {
    const fieldValue = request[field];
    if (
      fieldValue === undefined ||
      fieldValue === null ||
      fieldValue === '' ||
      (Array.isArray(fieldValue) && fieldValue.length === 0)
    ) {
      params.append(field, '');
      return;
    }

    buildQueryParams(params, fieldValue, field);
  });
}

enum EnumErrorCodes {
  SessionEnded = 5
}

export class WebApiService {
  websocket: WebSocket;
  subscribers = new Array<SocketSubscribersModel>();
  sendOrder = new Array<string>();
  url: string
  public cookieName = "Auth-Token";
  tokenSaveType: TokenSaveType = TokenSaveType.Cookies
  private readonly useHttpTransport: boolean;
  private readonly httpBaseUrl: string;
  private readonly localHttpBaseUrl: string;
  private refreshRequest: Promise<boolean> | null = null;
  /**
   *включить реконнекты при потере соединения
   *
   * @type {boolean}
   * @memberof WebApiService
   */
  reconnectEnabled: boolean = true
  /**
   *Время простоя перед реконнектом после потери соединения
   *
   * @type {number}
   * @memberof WebApiService
   */
  reconnectTimeout: number = 10 * 1000;
  /**
   *флаг обозначающий наличие подключения к вебсокету
   *
   * @type {boolean}
   * @memberof WebApiService
   */
  connected: boolean = false;
  /**
   * 
   * @param url url для подключения к вебсокету. должен начинаться с ws:// или с wss://
   */
  constructor(private baseUrl: string, cookieName: string = "Auth-Token", private microFront: boolean = false) {
    this.cookieName = cookieName;
    this.useHttpTransport = /^https?:\/\//i.test(baseUrl);
    this.httpBaseUrl = baseUrl.replace(/\/+$/, '');
    this.localHttpBaseUrl = typeof window !== 'undefined'
      ? window.location.origin.replace(/\/+$/, '')
      : this.httpBaseUrl;
  }
  public init() {
    if (this.useHttpTransport) {
      return;
    }
    this.initUrl();
    this.connect();
  }
  private initUrl() {
    this.url = this.addTokenToUrl(this.baseUrl);
  }
  /**
   * Подключиться к вебсокету
   */
  private connect() {
    this.dispose();
    if (this.microFront) {
      let key = this.baseUrl;
      if ((window as any).__proto__[key]) {
        this.websocket = (window as any).__proto__[key] as WebSocket;
      } else {
        this.websocket = new WebSocket(this.url);
        (window as any).__proto__[key] = this.websocket;
      }
    } else {
      this.websocket = new WebSocket(this.url);
    }
    this.websocket.onmessage = this.onMessage.bind(this);
    this.websocket.onopen = this.onOpen.bind(this);
    this.websocket.onerror = this.onError.bind(this);
    this.websocket.onclose = this.onClose.bind(this);
    this.connected = true;
  }
  private clearReconnect() {
    // удалить токен
    this.clearToken();
    // пересоздать урл с новым токеном
    this.initUrl();
    // переподключить
    this.connect();
  }
  /**
   * уничтожить объект вебсокет
   */
  private dispose() {
    if (!this.websocket)
      return;
    this.websocket.onmessage = null;
    this.websocket.onopen = null;
    this.websocket.onerror = null;
    this.websocket.onclose = null;
    this.websocket = null;
  }
  /**
   * Удаляем токен из куки
   */
  private clearToken() {
    if (this.tokenSaveType == TokenSaveType.Cookies) {
      Cookies.remove(this.cookieName);
    } else {
      localStorage.removeItem(this.cookieName)
    }
  }
  private newGuid(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  private getCookieToken(): string {
    var token = Cookies.get(this.cookieName);
    if (!token)
      token = this.newGuid();
    // 30 days
    Cookies.set(this.cookieName, token, { expires: new Date(new Date().getTime() + 30 * 24 * 60 * 60 * 1000) });
    return token;
  }

  private getLocalStorageToken(): string {
    var token = localStorage.getItem(this.cookieName);
    if (!token)
      token = this.newGuid();
    localStorage.setItem(this.cookieName, token);
    return token;
  }

  private getToken(): string {
    var token = "";
    switch (this.tokenSaveType) {
      case TokenSaveType.Cookies:
        token = this.getCookieToken();
        break;
      case TokenSaveType.LocalStore:
        token = this.getLocalStorageToken();
        break;
    }
    return token;
  }
  private addTokenToUrl(url: string): string {
    var token = this.getToken();
    if (url.indexOf('?') >= 0)
      return url + '&token=' + token;
    return url + '?token=' + token;
  }
  onMessage(msg: MessageEvent) {
    const json = JSON.parse(msg.data);
    var controller = json.Class;
    var method = json.Method;
    var data = json.Value;
    // if(!json.IsSuccess)
    //   console.error('error response: ',json)
    var callers = this.subscribers.filter(x => {
      return x.controller == controller && x.method == method;
    });
    callers.forEach(c => c.callback(json));
    var errorCode = (json || {}).ErrorCode || 0;
    if (errorCode == EnumErrorCodes.SessionEnded) {
      this.clearReconnect();
    }
  }
  onError(e: Event) {
    console.error('Websocket unexpected ERROR', e);
    this.connected = false;
  }
  onClose(e: CloseEvent) {
    console.error('Websocket CLOSED', e);
    this.connected = false;
    var self = this;
    if (this.reconnectEnabled)
      setTimeout(function () {
        self.connect();
      }, self.reconnectTimeout)
  }
  onOpen() {
    if (this.sendOrder) {
      this.sendOrder.forEach(so => this.websocket.send(so))
    }
    this.sendOrder = new Array<string>();
  }
  on(controller: string, method: string, callback: Function) {
    this.subscribers.push({
      controller: controller,
      method: method,
      callback: callback
    });
  }
  send(controller: string, method: string, data?: any) {
    if (this.useHttpTransport) {
      void this.sendHttp(controller, method, data);
      return;
    }
    var value = data;
    if (typeof data !== 'string')
      value = JSON.stringify(data === undefined || data === null ? '' : data)

    var sendData = JSON.stringify({
      controller: controller,
      method: method,
      value: value
    });
    if (this.websocket.readyState != 1) { // open
      this.sendOrder.push(sendData);
      return;
    }
    this.websocket.send(sendData)
  }

  private async sendHttp(controller: string, method: string, data?: any) {
    const routeKey = `${controller}.${method}`;
    const route = HTTP_ROUTE_MAP[routeKey];
    if (!route) {
      this.notify(controller, method, {
        Class: controller,
        Method: method,
        ErrorMessage: `HTTP route is not configured for ${routeKey}`,
        IsSuccess: false,
        Value: null,
      });
      return;
    }

    const { requestUrl, requestData } = this.buildHttpRequest(routeKey, route.httpMethod, route.path, data);
    const headers: Record<string, string> = {
      'Accept': 'application/json',
    };
    this.applyAuthorizationHeader(headers);

    const init: RequestInit = {
      method: route.httpMethod,
      headers,
      credentials: 'include',
      cache: 'no-store',
    };

    let requestBodyPayload: any = undefined;

    if (route.httpMethod !== 'GET' && requestData !== undefined) {
      headers['Content-Type'] = 'application/json';
      const bodyPayload = mapKeysDeep(requestData, toCamelCase);
      requestBodyPayload = normalizeListRequestPayload(
        route.keepNullBodyFields ? bodyPayload : pruneNilDeep(bodyPayload)
      );
      init.body = JSON.stringify(requestBodyPayload);
    }

    try {
      const { response, payload } = await this.executeHttpRequest(requestUrl, init, routeKey);
      const errorResponse: IHttpErrorPayload = {
        Class: controller,
        Method: method,
        ErrorMessage: this.getErrorMessage(payload) || response.statusText || `Request failed with status ${response.status}`,
        IsSuccess: false,
        Value: null,
        StatusCode: response.status,
      };

      if (response.status === 401) {
        this.handleUnauthorized(routeKey);
      }

      if (!response.ok) {
        if (shouldLogHttpError(routeKey, response.status)) {
          console.error('HTTP request failed', {
            routeKey,
            requestUrl,
            status: response.status,
            requestBody: requestBodyPayload,
            validationErrors: formatValidationErrors(payload),
            responseBody: payload,
            responseBodyJson: payload && typeof payload === 'object' ? JSON.stringify(payload, null, 2) : payload,
          });
        }
        this.notify(controller, method, errorResponse);
        return;
      }

      if (routeKey === LOGOUT_ROUTE_KEY) {
        this.clearToken();
      }
      this.notify(controller, method, {
        Class: controller,
        Method: method,
        ErrorMessage: '',
        IsSuccess: true,
        Value: mapHttpResponsePayload(payload, route),
      });
    } catch (error) {
      this.notify(controller, method, {
        Class: controller,
        Method: method,
        ErrorMessage: error instanceof Error ? error.message : 'HTTP request failed',
        IsSuccess: false,
        Value: null,
      });
    }
  }

  // Direct requests share the admin session and refresh flow.
  async requestHttpAsync<T>(path: string, method: HttpMethod = 'GET', data?: any, options: HttpRequestOptions = {}): Promise<T> {
    ensureRequestNotAborted(options.signal);
    const routeKey = `Http.${path}`;
    const headers: Record<string, string> = { Accept: 'application/json' };
    this.applyAuthorizationHeader(headers);
    const controller = new AbortController();
    const init: RequestInit = { method, headers, credentials: 'include', cache: 'no-store', signal: controller.signal };
    if (data !== undefined) {
      headers['Content-Type'] = 'application/json';
      init.body = JSON.stringify(pruneNilDeep(mapKeysDeep(data, toCamelCase)));
    }
    let timedOut = false;
    let timer: ReturnType<typeof setTimeout> = null;
    let rejectAbort: (error: Error) => void;
    const aborted = new Promise<IHttpResponsePayload>((_resolve, reject) => { rejectAbort = reject; });
    const onAbort = () => rejectAbort(timedOut ? new HttpRequestTimeoutError(options.timeoutMs) : requestAbortError());
    const onCallerAbort = () => controller.abort();
    controller.signal.addEventListener('abort', onAbort);
    if (options.signal) options.signal.addEventListener('abort', onCallerAbort);
    if (options.timeoutMs > 0) {
      timer = setTimeout(() => {
        timedOut = true;
        controller.abort();
      }, options.timeoutMs);
    }
    try {
      // Race the complete flow, including session refresh and response-body reading.
      // A shared refresh or a transport ignoring AbortSignal must not hold the UI open.
      const { response, payload } = await Promise.race([
        this.executeHttpRequest(`${this.httpBaseUrl}${path}`, init, routeKey),
        aborted,
      ]);
      if (response.status === 401) this.handleUnauthorized(routeKey);
      if (!response.ok) {
        throw new HttpRequestError(response.status, payload,
          this.getErrorMessage(payload) || `Сервис недоступен (код ${response.status}). Повторите позже.`);
      }
      return payload as T;
    } catch (error) {
      if (controller.signal.aborted) {
        throw timedOut ? new HttpRequestTimeoutError(options.timeoutMs) : requestAbortError();
      }
      throw error;
    } finally {
      if (timer !== null) clearTimeout(timer);
      controller.signal.removeEventListener('abort', onAbort);
      if (options.signal) options.signal.removeEventListener('abort', onCallerAbort);
    }
  }

  private async executeHttpRequest(requestUrl: string, init: RequestInit, routeKey: string): Promise<IHttpResponsePayload> {
    ensureRequestNotAborted(init.signal);
    const initialResponse = await this.fetchHttp(requestUrl, init, routeKey);
    ensureRequestNotAborted(init.signal);
    if (initialResponse.response.status !== 401 || !this.shouldRefreshRequest(routeKey)) {
      return initialResponse;
    }

    const isRefreshed = await this.refreshHttpSession();
    ensureRequestNotAborted(init.signal);
    if (!isRefreshed) {
      return initialResponse;
    }

    this.applyAuthorizationHeader(init.headers as Record<string, string>);
    return this.fetchHttp(requestUrl, init, routeKey);
  }

  private async fetchHttp(requestUrl: string, init: RequestInit, routeKey: string): Promise<IHttpResponsePayload> {
    ensureRequestNotAborted(init.signal);
    const cacheSafeRequestUrl = init.method === 'GET'
      ? this.addCacheBuster(requestUrl)
      : requestUrl;
    const response = await fetch(cacheSafeRequestUrl, init);
    ensureRequestNotAborted(init.signal);
    const payload = this.parseHttpResponse(await response.text());
    ensureRequestNotAborted(init.signal);
    if (response.ok && routeKey === LOGIN_ROUTE_KEY) {
      this.captureAuthToken(response, payload);
    }
    return {
      response,
      payload,
    };
  }

  private shouldRefreshRequest(routeKey: string): boolean {
    return routeKey !== LOGIN_ROUTE_KEY && routeKey !== LOGOUT_ROUTE_KEY;
  }

  private async refreshHttpSession(): Promise<boolean> {
    if (this.refreshRequest) {
      return this.refreshRequest;
    }

    this.refreshRequest = this.performRefreshHttpSession();
    try {
      return await this.refreshRequest;
    } finally {
      this.refreshRequest = null;
    }
  }

  private async performRefreshHttpSession(): Promise<boolean> {
    try {
      const response = await fetch(`${this.getHttpBaseUrl(GET_USER_INFO_ROUTE_KEY)}${AUTH_REFRESH_PATH}`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
        },
        credentials: 'include',
      });
      const responseText = await response.text();
      const payload = this.parseHttpResponse(responseText);
      if (response.ok) {
        this.captureAuthToken(response, payload);
      }
      return response.ok;
    } catch {
      return false;
    }
  }

  private buildHttpRequest(routeKey: string, httpMethod: HttpMethod, path: string, data?: any): IHttpRouteBuildResult {
    const httpBaseUrl = this.getHttpBaseUrl(routeKey);
    if (!/{[^}]+}/.test(path)) {
      const requestData = data;
      let requestUrl = `${httpBaseUrl}${path}`;
      if (
        httpMethod === 'GET' &&
        requestData &&
        Object.keys(requestData).length > 0
      ) {
        const query = new URLSearchParams();
        if (routeKey === 'BackgroundFileService.GetList') {
          buildRequiredListQueryParams(query, requestData, ['Search']);
        } else if (routeKey === 'BackgroundCategoryService.GetList') {
          buildRequiredListQueryParams(query, requestData, ['Search']);
        } else if (routeKey === 'MusicService.GetList') {
          buildRequiredListQueryParams(query, requestData, ['Name', 'Search']);
        } else if (routeKey === 'MusicService.GetCategories') {
          buildRequiredListQueryParams(query, requestData, ['Search']);
        } else {
          buildQueryParams(query, requestData);
        }
        const queryString = query.toString();
        if (queryString) {
          requestUrl += `${requestUrl.indexOf('?') >= 0 ? '&' : '?'}${queryString}`;
        }
      }

      return {
        requestUrl,
        requestData,
      };
    }

    const pathParamsSource = isPlainObject(data) ? data : { id: data };
    let requestPath = path;

    requestPath = requestPath.replace(/\{([^}]+)\}/g, (_match, key: string) => {
      const value = pathParamsSource[key];
      return encodeURIComponent(String(value === undefined || value === null ? '' : value));
    });

    let requestData = isPlainObject(data) ? { ...data } : undefined;
    if (isPlainObject(data)) {
      const matches = path.match(/\{([^}]+)\}/g) || [];
      matches.forEach((match) => {
        const key = match.slice(1, -1);
        delete requestData[key];
      });
      if (Object.keys(requestData).length === 0) {
        requestData = undefined;
      }
    }

    return {
      requestUrl: `${httpBaseUrl}${requestPath}`,
      requestData,
    };
  }

  private getHttpBaseUrl(routeKey: string): string {
    if (routeKey.indexOf('AccountService.') === 0) {
      return this.localHttpBaseUrl;
    }

    return this.httpBaseUrl;
  }

  private addCacheBuster(requestUrl: string): string {
    const separator = requestUrl.indexOf('?') >= 0 ? '&' : '?';
    return `${requestUrl}${separator}_=${Date.now()}`;
  }

  private parseHttpResponse(responseText: string): any {
    if (!responseText) {
      return null;
    }
    try {
      return JSON.parse(responseText);
    } catch {
      return responseText;
    }
  }

  private getErrorMessage(payload: any): string {
    if (!payload) {
      return '';
    }
    if (typeof payload === 'string') {
      return payload;
    }
    const validationErrors = formatValidationErrors(payload);
    return validationErrors || payload.ErrorMessage || payload.message || payload.error || payload.title || payload.detail || '';
  }

  private notify(controller: string, method: string, response: any) {
    const callers = this.subscribers.filter((subscriber) => {
      return subscriber.controller == controller && subscriber.method == method;
    });
    callers.forEach((caller) => caller.callback(response));
  }

  private handleUnauthorized(routeKey: string) {
    if (typeof window === 'undefined') {
      return;
    }
    if (routeKey !== GET_USER_INFO_ROUTE_KEY) {
      return;
    }
    const loginPath = '/page-login';
    if (window.location.pathname === loginPath) {
      return;
    }
    window.location.replace(loginPath);
  }

  private getStoredToken(): string {
    const tokenKeys = [
      this.cookieName,
      'AuthorizationToken',
      'accessToken',
      'AccessToken',
      'token',
    ];
    for (const key of tokenKeys) {
      const cookieToken = Cookies.get(key);
      if (this.normalizeJwtToken(cookieToken)) {
        return cookieToken;
      }
      const localToken = localStorage.getItem(key);
      if (this.normalizeJwtToken(localToken)) {
        return localToken;
      }
    }
    return '';
  }

  private applyAuthorizationHeader(headers: Record<string, string>) {
    if (!headers) {
      return;
    }
    const token = this.normalizeJwtToken(this.getStoredToken());
    if (token) {
      headers.Authorization = token;
    } else {
      delete headers.Authorization;
    }
  }

  private captureAuthToken(response: Response, payload: any) {
    const headerToken = response.headers.get('Authorization')
      || response.headers.get('X-Access-Token')
      || response.headers.get('X-Auth-Token');
    const payloadToken = payload && typeof payload === 'object'
      ? payload.accessToken
        || payload.AccessToken
        || payload.token
        || payload.Token
        || payload.value
        || payload.Value
      : typeof payload === 'string' ? payload : '';
    const token = this.normalizeJwtToken(headerToken || payloadToken);
    if (token) {
      this.saveToken(token);
    }
  }

  private normalizeJwtToken(token: string): string {
    if (!token) {
      return '';
    }
    const normalizedToken = token.indexOf('Bearer ') === 0 ? token : `Bearer ${token}`;
    const jwt = normalizedToken.slice('Bearer '.length).trim();
    return jwt.split('.').length === 3 ? `Bearer ${jwt}` : '';
  }

  private saveToken(token: string) {
    const normalizedToken = this.normalizeJwtToken(token);
    if (!normalizedToken) {
      return;
    }
    if (this.tokenSaveType == TokenSaveType.Cookies) {
      Cookies.set(this.cookieName, normalizedToken, { expires: new Date(new Date().getTime() + 30 * 24 * 60 * 60 * 1000) });
      return;
    }
    localStorage.setItem(this.cookieName, normalizedToken);
  }

}
interface SocketSubscribersModel {
  controller: string;
  method: string;
  callback: Function;
}
